import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ErrorMessageService {
  private readonly errorSubject = new Subject<string | undefined>();

  showError(message: string): void {
    this.errorSubject.next(message);
  }

  clear(): void {
    this.errorSubject.next(undefined);
  }

  get error$(): Observable<string | undefined> {
    return this.errorSubject.asObservable();
  }
}
